import { render, staticRenderFns } from "./DataImportDialog.vue?vue&type=template&id=03d04895&scoped=true"
import script from "./DataImportDialog.vue?vue&type=script&lang=js"
export * from "./DataImportDialog.vue?vue&type=script&lang=js"
import style0 from "./DataImportDialog.vue?vue&type=style&index=0&id=03d04895&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d04895",
  null
  
)

export default component.exports